export default class MenuItem {
    id: number
    url: string;
    icon: string
    'icon-alt'?: string
    text: string
    model: boolean
    children?: MenuItem[]
    menuItemParentId?: number
    routeParams?: object

    constructor (
        { id, url, icon, iconAlt, text, model, menuItemParentId, children, routeParams }:
        {
            id: number;
            url: string;
            icon: string;
            iconAlt: string;
            text: string;
            model: boolean;
            menuItemParentId?: number ;
            children?: MenuItem[];
            routeParams?: object;
        }) {
        this.id = id
        this.url = url
        this.icon = icon
        this['icon-alt'] = iconAlt
        this.text = text
        this.model = model
        this.menuItemParentId = menuItemParentId
        if (routeParams) this.routeParams = routeParams
        if (children) this.children = children
    }
}
